<template>
    <div class="d-flex flex-column align-items-center">

        <!-- Iterate mainElements -->
        <div
            v-for="(mainElementParameters, keyColumna, i) in app.currentConfiguration.mainElementParameters"
            :key="i"
            class="d-flex flex-column"
        >
            <div class="card card_size m-3 mb-5">
                <!-- ---------------- -->
                <!--   CARD HEADER    -->
                <!-- ---------------- -->
                <div class="card-header flex-column">
                    <div class="d-flex flex-row align-items-center justify-content-between">
                        <!-- check ok -->
                         <div style="width: 30px">
                            <i v-show="
                                    mainElementParameters['caras_columna'].value &&
                                    mainElementParameters['numero_mecanismos'].value &&
                                    mainElementParameters['unidades'].value"
                                class="size_check_desktop fa-lg far fa-check-circle ml-1 mr-3"
                                style="color: black"
                            ></i>
                        </div>

                        <div class="d-flex flex-column">
                            <!-- TITOL GAMA -->
                            <div class="p-1 m-1 font-weight-bold">
                                {{app.currentConfiguration.familyParameters["gama"].value.name}}
                            </div>

                            <!-- NUM UNITATS -->
                            <div class="pt-2 pb-2">
                                <div>
                                    <editParameterValueComponent
                                        :parameter="mainElementParameters['unidades']"
                                        :value.sync="mainElementParameters['unidades'].value"
                                        :placeholder_titel="
                                            mainElementParameters['unidades'].attribute.name
                                        "
                                        :style_title="'width: auto;'"
                                        :style_edit_param="'width:80px; text-align:right; padding-right:15px'"

                                        :labelOverInput="false"
                                        :prop_title_show="true"

                                        @update:value="refreshParameters"
                                    ></editParameterValueComponent>
                                </div>
                            </div>
                        </div>

                        <!-- BUTO BORRAR -->
                        <button
                            @click.stop="cleanSpecificSelectors(keyColumna)"
                            style="
                                font-weight: lighter;
                                border-radius: 50%;
                                height: 40px;
                                width: 40px;
                            "
                            class="btn btn-outline-secondary ml-2"
                        >
                            <i class="fas fa-trash-alt"></i>
                        </button>
                    </div>
                </div>

                <!-- ---------------- -->
                <!--    CARD BODY     -->
                <!-- ---------------- -->
                <div class="card-body m-3">
                    <form @submit.prevent="">

                        <img
                            v-if="isMobile"
                            :src="mainElementParameters['numero_mecanismos'].value ?
                                mainElementParameters['numero_mecanismos'].value.image :
                                mainElementParameters['numero_mecanismos'].values[0].image"
                            class="img_size_mobile mb-3"
                        />

                        <div class="d-flex flex-row align-items-center">

                            <div class="d-flex flex-column">
                                <editParameterValueComponent
                                    v-if="isMobile && app.market.id !='chile'"
                                    ref="editParameterValueComponent"
                                    :id="i + '_' + randomId + '_numero_mecanismos'"
                                    :labelOverInput="true"
                                    :parameter="mainElementParameters['numero_mecanismos']"
                                    :value.sync="mainElementParameters['numero_mecanismos'].value"
                                    :field_type="'radiobutton'"
                                    @update:value="refreshParameters"
                                    :showAllRadiobuttons="true"
                                    class="mb-2"
                                ></editParameterValueComponent>
                                <editParameterValueComponent
                                    v-if="isMobile && app.market.id =='chile'"
                                    ref="editParameterValueComponent"
                                    :id="i + '_' + randomId + '_numero_placas'"
                                    :labelOverInput="true"
                                    :parameter="mainElementParameters['numero_placas']"
                                    :value.sync="mainElementParameters['numero_placas'].value"
                                    :field_type="'radiobutton'"
                                    @update:value="refreshParameters"
                                    :showAllRadiobuttons="true"
                                    class="mb-2"
                                ></editParameterValueComponent>
                                <editParameterValueComponent
                                    v-if="isMobile"
                                    ref="editParameterValueComponent"
                                    :labelOverInput="true"
                                    :id="i + '_' + randomId + '_caras_columna'"
                                    :parameter="mainElementParameters['caras_columna']"
                                    :value.sync="mainElementParameters['caras_columna'].value"
                                    :field_type="'radiobutton'"
                                    @update:value="refreshParameters"
                                    :showAllRadiobuttons="true"
                                    class="mb-2"
                                ></editParameterValueComponent>
                            </div>

                            <img
                                v-if="!isMobile"
                                :src="mainElementParameters['numero_mecanismos'].value ?
                                    mainElementParameters['numero_mecanismos'].value.image :
                                    mainElementParameters['numero_mecanismos'].values[0].image"
                                class="img_size_desktop mr-5"
                            />
                            <div
                                v-if="!isMobile"
                                class="d-flex flex-column"
                            >
                                <editParameterValueComponent
                                    ref="editParameterValueComponent"
                                    v-if="app.market.id !='chile'"
                                    :id="i + '_' + randomId + '_numero_mecanismos'"
                                    :labelOverInput="true"
                                    :parameter="mainElementParameters['numero_mecanismos']"
                                    :value.sync="mainElementParameters['numero_mecanismos'].value"
                                    :field_type="'radiobutton'"
                                    @update:value="refreshParameters"
                                    :showAllRadiobuttons="true"
                                    class="mb-2"
                                ></editParameterValueComponent>
                                <editParameterValueComponent
                                    ref="editParameterValueComponent"
                                    v-if="app.market.id=='chile'"
                                    :id="i + '_' + randomId + '_numero_placas'"
                                    :labelOverInput="true"
                                    :parameter="mainElementParameters['numero_placas']"
                                    :value.sync="mainElementParameters['numero_placas'].value"
                                    :field_type="'radiobutton'"
                                    @update:value="refreshParameters"
                                    :showAllRadiobuttons="true"
                                    class="mb-2"
                                ></editParameterValueComponent>
                                <editParameterValueComponent
                                    ref="editParameterValueComponent"
                                    :labelOverInput="true"
                                    :id="i + '_' + randomId + '_caras_columna'"
                                    :parameter="mainElementParameters['caras_columna']"
                                    :value.sync="mainElementParameters['caras_columna'].value"
                                    :field_type="'radiobutton'"
                                    @update:value="refreshParameters"
                                    :showAllRadiobuttons="true"
                                    class="mb-2"
                                ></editParameterValueComponent>
                            </div>
                        </div>
                    </form>
                </div>

                <!-- ------------- -->
                <!-- REMOVE BUTTON -->
                <!-- ------------- -->
                <div class="d-flex flex-row align-items-center justify-content-center">
                    <button
                        v-show="showDeleteButton"
                        @click="removebandeja(keyColumna, keyColumna + '_loading_remove')"
                        class="btn btn-outline-dark btn_rounded btn_size"
                        style="z-index: 998;"
                        :style="'position: absolute; top:' + topPositionRemoveButton + 'px' +
                            '; left: ' + leftPositionRemoveButton + 'px;'"
                    >
                        <i
                            v-if="buttonsLoading[keyColumna + '_loading_remove']"
                            class="fa fa-spinner fa-spin"
                        ></i>
                        <i v-else class="fas fa-minus fa-sm"></i>
                    </button>
                </div>

            </div>
        </div>

        <!-- ADD BUTTON -->
        <button
            @click="addElement('loading_add_button')"
            class="btn btn-outline-dark btn_rounded btn_size"
            :style="'z-index: 998; position: relative; top:' + topPositionAddButton + 'px' +
                            '; left: ' + leftPositionAddButton + 'px;'"
        >
            <i
                v-if="buttonsLoading['loading_add_button']"
                class="fa fa-spinner fa-spin"
            ></i>
            <i v-else class="fas fa-plus fa-sm"></i>
        </button>
    </div>
</template>

<script>
import Vue from "vue";
import { app } from "../../application.js";
import editParameterValueComponent from "./../editParameterValue.vue";
import { parse } from "path";

export default {
    name: "mainElements50tComponent",
    data() {
        return {
            app: app,
            confirmBeforeLeave: true,
            parameters: [],
            mainElementDistribution: "",
            randomId: Math.random()
                .toString(36)
                .replace(/[^a-z]+/g, "")
                .substr(2, 10),
            labelOverDropdown: true,
            crossCompartimentosDimensiones: [],
            lastchangedInputId: "",
            window: { width: 0, height: 0 },
            buttonsLoading: [],
            multiLevel: app.multiLevelHelper,
            timeout: {},
            idgama: "",
        };
    },
    components: { editParameterValueComponent },
    computed: {
        isMobile: function () {
            let a = this.window.width < 900;
            return a;
        },
        isDesktop: function () {
            let a = this.window.width > 900;
            return a;
        },
        leftPositionAddButton: function () {
            if (this.isDesktop) {
                return 0;
            } else if (this.isMobile) {
                return 30;
            }
        },
        topPositionAddButton: function () {
            if (this.isDesktop) {
                return -30;
            } else if (this.isMobile) {
                return -38;
            }
        },
        leftPositionRemoveButton: function () {
            if (this.isDesktop) {
                return -70;
            } else if (this.isMobile) {
                return 110;
            }
        },
        topPositionRemoveButton: function () {
            if (this.isDesktop) {
                return 300;
            } else if (this.isMobile) {
                return 1145;
            }
        },
        input_width: function () {
            return 170;
        },
        imgSize: function () {
            if (this.isMobile) {
                return 200;
            }
            return 250;
        },
        showDeleteButton: function () {
            return (
                Object.keys(app.currentConfiguration.mainElementParameters)
                    .length > 1
            );
        },
    },
    methods: {
        addElement: async function (key = null) {
            var self = this;
            Vue.set(self.buttonsLoading, key, 1);
            await this.multiLevel.addElement();
            Vue.set(self.buttonsLoading, key, 0);
        },
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
        cleanAllSelectors: async function () {
            console.log("cleanAllSelectors...");

            //loop through mainElementParameters values resetting all selected values in currentConfiguration.mainElementParameters
            let mainparams = this.app.currentConfiguration
                .mainElementParameters;

            Object.values(mainparams).map((mainparam) => {
                Object.values(mainparam).map((item) => {
                    if (item.value.constructor.name == "Array") {
                        item.value = [];
                    } else {
                        item.value = "";
                    }
                });
            });

            this.refreshParameters();
        },
        cleanSpecificSelectors: async function (selectedKey) {

            let selectedElement = this.app.currentConfiguration
                .mainElementParameters[selectedKey];

            if (selectedElement) {
                Object.values(selectedElement).map((elProperty) => {
                    if (elProperty.value.constructor.name == "Array") {
                        elProperty.value = [];
                    } else {
                        elProperty.value = "";
                    }
                });
            }

            this.refreshParameters();
        },
        refreshParameters: async function (e, key_remove_loading) {
            await this.app.asyncProcess(false, false);
            //await this.processDelay(e, key_remove_loading);
        },
        processDelay: async function(e, key_remove_loading) {
            var self = this;
            self.timeout = setTimeout(async function() {

                //self.appendSpinnerToTextbox(key_remove_loading);

                await self.app.asyncProcess(false);

                //self.removeSpinnerFromTextbox(key_remove_loading);

            }, 600);
        },
        quantityChanged: async function(e, key_remove_loading) {

            var self = this;

            //com a minim el valor ha de ser 0
            //self.element.quantity = self.element.quantity || 0;

            //si usuari escriu nums haventhi ja un 0 treu el 0 de davant
            // if (self.element.quantity.toString().startsWith("0")) {
            //     self.element.quantity = parseFloat(
            //         self.element.quantity.toString().slice(1)
            //     );
            // }

            //sempre en cualsevol cambi actualitza linea
            //self.element.subtotal = self.element.quantity * self.element.price;

            if (self.lastchangedInputId != e.target.id) {
                await self.processDelay(e, key_remove_loading);
                self.lastchangedInputId = e.target.id;

            } else if (self.lastchangedInputId == e.target.id) {
                clearTimeout(self.timeout);
                await self.processDelay(e, key_remove_loading);
                self.lastchangedInputId = e.target.id;
            }
        },
        removebandeja: async function (keyBandejaABorrar, key_remove_loading) {
            var self = this;

            Vue.set(this.buttonsLoading, key_remove_loading, 1);

            this.$nextTick(async () => {

                delete self.app.currentConfiguration.mainElementParameters[
                    keyBandejaABorrar
                ];

                self.bandejas = self.app.currentConfiguration.mainElementParameters;

                self.renombraBandejas();

                await app.asyncProcess(false, false);

                Vue.set(self.buttonsLoading, key_remove_loading, 0);
            });

        },
        renombraBandejas: function () {
            let newKey = 0;
            Object.entries(
                this.app.currentConfiguration.mainElementParameters
            ).forEach(([key, value]) => {
                newKey += 1;
                if (
                    this.app.currentConfiguration.mainElementParameters.hasOwnProperty(
                        key
                    )
                ) {
                    delete this.app.currentConfiguration.mainElementParameters[
                        key
                    ];
                    this.app.currentConfiguration.mainElementParameters[
                        newKey
                    ] = value;
                }
            });
            //actualiza bandejas amb els noms cambiats
            //this.bandejas = this.app.currentConfiguration.mainElementParameters;
        },
    },
    created() {
        //get window size
        window.addEventListener("resize", this.handleResize);
        this.handleResize();

        this.idgama =
            app.currentConfiguration.familyParameters["gama"].value.id;
    },
    destroyed() {
        window.removeEventListener("resize", this.handleResize);
    },
    async beforeMount() {},
};
</script>

<style scoped lang="scss">
.btn_size {
    width: 42px;
    height: 42px;
}
.img_size_desktop{
    width:350px;
    height:350px;
}
.img_size_mobile{
    width:250px;
    height:250px;
}
</style>
